import script from "./AdminFormElementCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementCheckbox.vue?vue&type=style&index=0&id=7b485c13&lang=scss&scope=true"

const __exports__ = script;

export default __exports__